import React from "react";
import {observer} from "mobx-react";
import {
    IJourneyShoppingCartViewModel
} from "../../../services/booking/models/shopping-cart/journey/journey-shopping-cart-view-model.interface";
import {TicketFeesComponent} from "./ticket-fees.component";

interface TicketJourneyExtrasComponentProps {
    journeyCart: IJourneyShoppingCartViewModel;
}
export const TicketJourneyExtrasComponent: React.FC<TicketJourneyExtrasComponentProps> = observer((props) => {
    const extrasFees = [
        ...props.journeyCart.seatsFees,
        ...props.journeyCart.ssrsFees,
        ...props.journeyCart.otherFees
    ]

    return (
        <TicketFeesComponent fees={extrasFees}/>
    );
})